import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityComercializacionesState, entityComercializacionesAdapter } from './comercializaciones.state';

import {
  entityComercializacionesAddFailure,
  entityComercializacionesAddRequest,
  entityComercializacionesAddSuccess,
  entityComercializacionesLoadFailure,
  entityComercializacionesLoadRequest,
  entityComercializacionesLoadSuccess
} from './comercializaciones.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityComercializacionesLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityComercializacionesLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityComercializacionesLoadSuccess, (state, { items }) =>
    entityComercializacionesAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityComercializacionesAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityComercializacionesAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityComercializacionesAddSuccess, (state, { item }) =>
    entityComercializacionesAdapter.addMany(item, {
      ...state,
      isLoading: false,
      error: null
    })
  )  
);

export function comercializacionesReducer(
  state: EntityComercializacionesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
